import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

serviceWorkerRegistration.register({
    onSuccess: (registration) => {
        console.log('Service Worker registered', registration)
    },
    onUpdate: (registration) => {
        console.log('Service Worker updated', registration)
    }
})

const rootElement = document.getElementById('root') as HTMLElement
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement)
    root.render(
        <React.StrictMode>
            <App/>
        </React.StrictMode>
    );
} else {
    const root = ReactDOM.createRoot(document.getElementById('main-container') as HTMLElement)
    root.render(
        <></>
    )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
